/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateTuitionRateTierResponse
 */
export interface CreateTuitionRateTierResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateTuitionRateTierResponse
     */
    id: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateTuitionRateTierResponse interface.
 */
export function instanceOfCreateTuitionRateTierResponse(value: object): value is CreateTuitionRateTierResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateTuitionRateTierResponseFromJSON(json: any): CreateTuitionRateTierResponse {
    return CreateTuitionRateTierResponseFromJSONTyped(json, false);
}

export function CreateTuitionRateTierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTuitionRateTierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
    };
}

export function CreateTuitionRateTierResponseToJSON(json: any): CreateTuitionRateTierResponse {
    return CreateTuitionRateTierResponseToJSONTyped(json, false);
}

export function CreateTuitionRateTierResponseToJSONTyped(value?: CreateTuitionRateTierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
    };
}

